import { useState } from "react";
import { api, ApiError } from "./api.ts";
import { ErrorBanner } from "./ErrorBanner.tsx";
import { Modal } from "./Modal.tsx";

interface Props {
  title: string;
  description: string;
  endpoint: string;
  onClose: () => void;
  onDeleted: () => void;
}

export function DeleteConfirm({
  title,
  description,
  endpoint,
  onClose,
  onDeleted,
}: Props) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function confirm() {
    setError(null);
    setBusy(true);
    try {
      await api(endpoint, { method: "DELETE" });
      onDeleted();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      title={title}
      onClose={onClose}
      footer={
        <>
          <button
            type="button"
            className="luna-btn luna-btn-ghost"
            onClick={onClose}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="button"
            className="luna-btn luna-btn-danger"
            onClick={() => void confirm()}
            disabled={busy}
          >
            {busy ? "Deleting…" : "Delete"}
          </button>
        </>
      }
    >
      {error && <ErrorBanner code={error} />}
      <div className="delete-confirm">
        <p>{description}</p>
        <p className="warn">This action cannot be undone.</p>
      </div>
    </Modal>
  );
}
